// @flow

export const HEADER_MESSAGE_KEYS = [
  'floorPlan',
  'bedsBath',
  'currentGrossRent',
  'newGrossRent',
  'currentUtilityAllowance',
  'newUtilityAllowance',
];

export const transparentRowSx = {
  backgroundColor: 'transparent !important',
  height: 'auto',
};

export const headCellSx = {
  borderBottom: 1,
  borderColor: 'divider',
  py: 0.5,
  px: 1,
};

export const bodyCellSx = {
  borderBottom: 'none',
  py: 0.5,
  px: 1,
  verticalAlign: 'top',
};

export const tableContainerSx = {
  width: '100%',
  overflowX: 'auto',
  overflowY: 'visible',
};

export const tableSx = {
  width: '100%',
  minWidth: 720,
  '& .MuiTableCell-root': {
    overflow: 'visible',
  },
};

export const FLOOR_PLAN_NAME_MAX_WIDTH_CH = 11;

export const floorPlanNameTypographySx = {
  display: 'block',
  maxWidth: `${FLOOR_PLAN_NAME_MAX_WIDTH_CH}ch`,
};

export const floorPlanCellSx = {
  ...bodyCellSx,
  maxWidth: `calc(${FLOOR_PLAN_NAME_MAX_WIDTH_CH}ch + 16px)`,
  overflow: 'hidden',
};

export const INPUT_WIDTH_PX = 149;

const inputColumnSx = {
  px: 0.5,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
};

export const inputHeadCellSx = {
  ...headCellSx,
  ...inputColumnSx,
};

export const inputCellSx = {
  ...bodyCellSx,
  ...inputColumnSx,
};

export const compactCurrencyInputSx = {
  m: 0,
  width: INPUT_WIDTH_PX,
  maxWidth: INPUT_WIDTH_PX,
  '& .MuiOutlinedInput-root': {
    height: 32,
    minHeight: 32,
  },
};

export const currencyInputErrorHelperTextProps = {
  sx: {
    mt: '2px',
    mb: 0,
    ml: 0,
    lineHeight: 1.2,
    whiteSpace: 'normal',
  },
};
